import { render, staticRenderFns } from "./handbook.vue?vue&type=template&id=1281b134&scoped=true&"
import script from "./handbook.vue?vue&type=script&lang=js&"
export * from "./handbook.vue?vue&type=script&lang=js&"
import style0 from "./handbook.vue?vue&type=style&index=0&id=1281b134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1281b134",
  null
  
)

export default component.exports